import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Divider, IconButton, MenuItem, Checkbox, Grid, Select, FormControl, InputLabel, Dialog, DialogContent } from "@mui/material";
import * as Yup from "yup";
import DeleteIcon from "@mui/icons-material/Delete";
import '../../../assets/ExtraStyle.css'
import { useFormik } from "formik";
import { AddNewQuestion, ApiuploadDocuments, GetCategories, GetEntities, UpdateQuestion } from "../../../apiService/Core/Apicall.tsx";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import upload from '../../../assets/images/upload.png'
import imageCompression from 'browser-image-compression';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ReactQuill from "react-quill-new";
import 'react-quill/dist/quill.snow.css';

import PatchedReactQuill from "../ManageVenue/PatchedReactQuill.tsx";
import store from "../../../global/config/store.ts";
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts";



const quillModules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        [{ font: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['bold', 'italic', 'underline'],
        ['link'],
        [{ align: [] }],
        ['script'],
        [{ color: [] }, { background: [] }],
        ['clean'],
    ],
};

const quillFormats = [
    'header', 'font', 'list', 'bullet',
    'bold', 'italic', 'underline',
    'link', 'align', 'script',
    'color', 'background',
];


interface Option {
    id: number;
    text: string;
    commentEnabled: boolean;
    minCommentLength: string;
}
interface FormValues {
    questions: string;
    entityTypeId: number
    categoryId: number
    isPhotoRequire: boolean
    isCommentBox: boolean
    minPhoto: number
    maxScore: number
    displayOrder: 1
    isScore: boolean
    questionGroup: string
    questionDescription: string
    questionHint: string
    qType: string
    minChar: number
    createdBy: number
    questionWeightage: number
    questionHintImages: string
    qOptionJson: Array<{
        optionId: number;
        value: string;
        optionScore: number;
        optionImage: number;
        optionComment: string;
        optionCommentType: string,
        optionCommentLabel: string,
        minChar: number;
        radioRatingComment: string;
    }>
}


const CreateNewQuestion: React.FC = () => {
    const location = useLocation();
    const questionData = location.state?.questionData;
    const [category, setcategorey] = useState<any>([])
    const [entity, setentity] = useState<any>('')
    const [ShowError, setShowError] = useState<boolean>(false)
    const [isConfirm, setisConfirm] = useState<boolean>(false)
    const [isCreateNew, setisCreateNew] = useState<boolean>(false)
    const [uploadedimage, setuploadedimage] = useState<any[]>(questionData && questionData.questionHintImages ? questionData.questionHintImages.split(",") : [])
    const navigate = useNavigate()
    // console.log(" questionData?.qOptionJson",  questionData?.qOptionJson);
    const addOption = () => {
        formik.setFieldValue("qOptionJson", [
            ...formik.values.qOptionJson,
            {
                optionId: formik.values.qOptionJson.length + 1,
                value: '',
                optionScore: 0,
                optionImage: 0,
                optionComment: "no",
                radioRatingComment: "",
                optionCommentType: "",
                optionCommentLabel: '',
                minChar: 0
            }
        ]);
    };
    const parseHtmlToText = (htmlString: string) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        return doc.body.textContent || "";
    };
    useEffect(() => {
        const fetchcategory = async () => {
            try {
                const categories = await GetCategories()
                setcategorey(categories.data)
            }
            catch (error) {
                toast.error(error)
            }

        }
        const fetchentities = async () => {
            try {
                const entities = await GetEntities()
                setentity(entities.data)
            }
            catch (error) {
                toast.error(error)
            }
        }
        fetchcategory()
        fetchentities()
    }, [])


    const initialValues: FormValues = {
        questions: (questionData && parseHtmlToText(questionData?.questions)) || '',
        entityTypeId: (questionData?.entityTypeId?.entityTypeId) || 0,
        categoryId: (questionData?.categoryId?.categoryId) || 0,
        qType: (questionData?.qType) || 'R',
        displayOrder: (questionData?.displayOrder) || 1,
        maxScore: (questionData?.maxScore) || 0,
        questionDescription: (questionData?.questionDescription) || '',
        questionHint: (questionData?.questionHint) || '',
        questionWeightage: (questionData?.questionWeightage) || 1,
        isPhotoRequire: (questionData?.isPhotoRequire) || false,
        isCommentBox: (questionData?.isCommentBox) || false,
        questionHintImages: (questionData?.questionHintImages) || '',
        minPhoto: (questionData?.minPhoto) || 0,
        questionGroup: (questionData?.questionGroup) || '',
        isScore: (questionData?.isScore) || false,
        minChar: (questionData?.minChar) || 0,
        createdBy: (questionData?.cretedBy) || 0,
        qOptionJson: questionData?.qOptionJson.length > 2 ? JSON.parse(questionData?.qOptionJson) : [
            {
                optionId: 1,
                value: '',
                optionScore: 0,
                optionImage: 0,
                optionComment: "no",
                radioRatingComment: '',
                optionCommentLabel: '',
                optionCommentType: 'text',
                minChar: 0
            }
        ],
    };
    const validationSchema = Yup.object({
        questions: Yup.string().required("Enter question name"),
        qType: Yup.string(),
        qOptionJson: Yup.array()
            .of(
                Yup.object().shape({
                    optionId: Yup.number().required("Option ID is required"),
                    value: Yup.string().when(['optionId', 'qType'], {
                        is: (optionId: number, qType: string) => !!optionId && qType === 'R',
                        then: (schema) => schema.required("Option Value is required"),
                        otherwise: (schema) => schema.notRequired(),
                    }),
                    score: Yup.number()
                        .typeError("Score must be a number")
                        .test("max-score", "Score must be less than max score", function (value) {
                            return value === undefined || value < formik.values.maxScore;
                        }),
                })
            )
            .when("qType", {
                is: "R",
                then: (schema) => schema.min(1, "At least one option is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

    })
    useEffect(() => {
        if (category.length > 0 && !category.some(cat => cat.categoryId === formik.values.categoryId)) {
            formik.setFieldValue("categoryId", category[0].categoryId);
        }
        if (entity.length > 0 && !entity.some(ent => ent.entityTypeId === formik.values.entityTypeId)) {
            formik.setFieldValue("entityTypeId", entity[0].entityTypeId);
        }
    }, [category, entity]);
    const getFormattedOptions = (values: any) => {
        if (values.qType === "R") {
            return values.qOptionJson.map(({
                minChar,
                optionComment,
                optionId,
                optionImage,
                optionScore,
                optionCommentType,
                optionCommentLabel,
                value
            }) => ({
                minChar,
                optionComment,
                optionId,
                optionImage,
                optionScore,
                optionCommentType,
                optionCommentLabel,
                value
            }));
        } else if (values.qType === "C") {
            return values.qOptionJson.map(({ optionId, value }) => ({
                optionId,
                value
            }));
        } else if (values.qType === "r") {
            return values.qOptionJson.map(({
                minChar,
                optionComment,
                optionId,
                optionImage,
                optionScore,
                optionCommentType,
                optionCommentLabel,
                value,
                radioRatingComment
            }) => ({
                minChar,
                optionComment,
                optionId,
                optionImage,
                optionScore,
                optionCommentType,
                optionCommentLabel,
                value,
                radioRatingComment
            }));
        } else {
            return [];
        }
    };

    const onSubmit = async (values: FormValues) => {
        const maxScore = Number(values.maxScore);

        const invalidOption = values.qOptionJson.find(
            (item) => Number(item.optionScore) > maxScore
        );

        if (invalidOption) {
            alert("Option Score should be less than Max Score");
            return;
        }
        const updatedValues = {
            ...values,
            ...(questionData ? { questionId: questionData.questionId } : {}),
            ...(questionData ? { isCreateNew: isCreateNew } : {}),
            isScore: values.maxScore > 0,
            maxScore: Number(values.maxScore),
            minChar: Number(values.minChar),
            minPhoto: Number(values.minPhoto),
            questionWeightage: Number(values.maxScore) == 0 ? 0 : Number(values.questionWeightage),
            createdBy: Number(localStorage.getItem('createdBy')),
            isCommentBox: false,
            qOptionJson: getFormattedOptions(values),
            questionHintImages: uploadedimage.join(',')
        };
        console.log("Added Data", updatedValues);

        const submitData = await (questionData?.questionId ? UpdateQuestion(updatedValues) : AddNewQuestion(updatedValues))
        console.log(updatedValues)
        toast.success(submitData.message)
        navigate('/admin/question-bank')
    }
    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit
    });

    // ----------------------------------------------------------File Upload ---------------------------------------
    const fileupload = async (filePath: any, fileType: any) => {
        // const userData: any = localStorage.getItem('userData');
        const formData = new FormData();
        // formData.append("userId", userData.userId);
        formData.append("fileType", fileType);
        formData.append("file", filePath); // Add a file
        try {
            const response: any = await ApiuploadDocuments(formData);
            if (response.status) {
                console.log("Uploaded File URL", response)
                setuploadedimage([...uploadedimage, response.location])
                // formik.setFieldValue(fileType, response.location);
            }
        }
        catch (error) {
            // console.log(error)
        }

    }

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if (file && file.type.startsWith("image/")) {
            try {
                store.dispatch(setLoadingTrue())
                const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 800,
                    useWebWorker: true,
                };

                const compressedFile = await imageCompression(file, options);


                fileupload(compressedFile, 'question_hint_image');
            } catch (error) {
                console.error("Image compression failed:", error);
                alert("Image compression failed. Please try again.");
            }
            finally {
                store.dispatch(setLoadingFalse())
            }
        } else {
            alert("Please upload a valid image file.");
        }
    };

    const handleRemove = (indexToRemove: number) => {
        setuploadedimage(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    const handlechnagemaxScore = (e) => {
        formik.setFieldValue('maxScore', e.target.value);
    }

    return (

        <Box className="box-container1 extra" minHeight="calc(100vh - 180px)" p={3} >
            {/* Header */}
            < form onSubmit={formik.handleSubmit} >
                <Box className='d-flex justify-content-between align-items-center mb-2'>
                    <Typography variant="h6" >
                        Create New Question
                    </Typography>
                    <Button className="bg-grey transform px-5 text-light" type={!questionData?.questionId ? "submit" : 'button'} onClick={() => { setShowError(true); questionData?.questionId && setisConfirm(true) }}>
                        Save
                    </Button>
                </Box>

                <Divider className="w-100 my-2 mb-3" />

                <FormControl className="w-100 my-3 mt-4 ">
                    <InputLabel shrink={false}>Your Question</InputLabel>
                    <TextField
                        className="w-100"
                        placeholder="Write your Question here..."
                        variant="outlined"
                        fullWidth
                        value={formik.values.questions}
                        onChange={(e) => formik.setFieldValue('questions', e.target.value)}
                    />
                    {ShowError && formik.errors.questions && <Typography className="text-danger">{formik.errors.questions}</Typography>}

                </FormControl>

                <Box className="d-flex w-100 my-4 flex-wrap" gap='5px'>
                    <FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Category</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formik.values.categoryId}
                            onChange={(e) => formik.setFieldValue('categoryId', e.target.value)}
                        >
                            {category.length > 0 &&
                                category.map((cat) => (
                                    <MenuItem value={cat.categoryId} key={cat.categoryId}>
                                        {cat.categoryName}
                                    </MenuItem>
                                ))
                            }

                        </Select>
                    </FormControl>
                    < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Business Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formik.values.entityTypeId}
                            onChange={(e) => formik.setFieldValue('entityTypeId', e.target.value)}
                        >
                            {entity.length > 0 &&
                                entity.map((cat) => (
                                    <MenuItem value={cat.entityTypeId} key={cat.entityTypeId}>
                                        {cat.entityTypeName}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label3" shrink={false}>Answer Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label3"
                            id="demo-simple-select-label3"
                            value={formik.values.qType}
                            onChange={(e) => formik.setFieldValue('qType', e.target.value)}
                        >
                            <MenuItem value="R">Radio Selection</MenuItem>
                            <MenuItem value="T">TextBox</MenuItem>
                            <MenuItem value="C">CheckBox</MenuItem>
                            <MenuItem value="r">Radio Rating Box</MenuItem>
                        </Select>
                    </FormControl>
                    < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Score</InputLabel>
                        <TextField onBlur={(e) => {
                            const value = parseInt(e.target.value, 10);
                            if (isNaN(value) || value < 0) {
                                toast.error('Number Should be positive')
                                formik.setFieldValue('maxScore', '0');
                            }
                        }} inputProps={{ min: 0 }} type="number" value={formik.values.maxScore} onChange={(e) => { handlechnagemaxScore(e) }} />
                    </FormControl>
                    < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Question Weightage</InputLabel>
                        <TextField
                            disabled={formik.values.maxScore == 0}
                            onBlur={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (isNaN(value) || value < 0) {
                                    toast.error('Number Should be more than Zero')
                                    formik.setFieldValue('questionWeightage', 1);
                                }
                            }}
                            inputProps={{ min: 1 }} type="number" value={formik.values.maxScore == 0 ? 0 : formik.values.questionWeightage} onChange={(e) => {formik.setFieldValue('questionWeightage', e.target.value) }} />
                    </FormControl>
                    <FormControl className="w-33" fullWidth>
                        <InputLabel shrink={false}>
                            Will this question have an upload Image/File option?
                        </InputLabel>
                        <Select
                            {...formik.getFieldProps("isPhotoRequire")}
                            onChange={(event) => formik.setFieldValue("isPhotoRequire", event.target.value === "true")}
                            value={formik.values.isPhotoRequire}
                        >
                            <MenuItem value={"true"}>Yes</MenuItem>
                            <MenuItem value={"false"}>No</MenuItem>
                        </Select>
                    </FormControl>
                    {formik.values.isPhotoRequire === true && (
                        <FormControl fullWidth className="w-33">
                            <InputLabel shrink={false}>Minimum Number of Images to UploadInputLabel</InputLabel>
                            <TextField
                                onBlur={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (isNaN(value) || value < 0) {
                                        toast.error('Number Should be positive')
                                        formik.setFieldValue('minChar', '0');
                                    }
                                }}
                                inputProps={{ min: 0 }} type="number" value={formik.values.minPhoto} onChange={(e) => { formik.setFieldValue('minPhoto', e.target.value) }} />

                        </FormControl>
                    )}
                    {formik.values.qType === "T" && (
                        <FormControl fullWidth className="w-33">
                            <InputLabel shrink={false}>Min. Characters for Comment</InputLabel>
                            <TextField
                                onBlur={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (isNaN(value) || value < 0) {
                                        toast.error('Number Should be positive')
                                        formik.setFieldValue('minChar', '0');
                                    }
                                }}
                                inputProps={{ min: 0 }} type="number" value={formik.values.minChar} onChange={(e) => { formik.setFieldValue('minChar', e.target.value) }} />

                        </FormControl>
                    )}
                    <FormControl className="w-33" fullWidth>
                        <InputLabel shrink={false}>
                            Question Group
                        </InputLabel>
                        <Select
                            {...formik.getFieldProps("questionGroup")}
                            onChange={(event) => formik.setFieldValue("questionGroup", event.target.value)}
                            value={formik.values.questionGroup}
                            displayEmpty
                        >
                            <MenuItem value="">
                                None
                            </MenuItem>
                            <MenuItem value="M">Moments that matter</MenuItem>
                            <MenuItem value="C">Compliance</MenuItem>
                            <MenuItem value="L">Liquor</MenuItem>
                        </Select>
                    </FormControl>
                    {/* < FormControl fullWidth className="w-50">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Description</InputLabel>
                        <TextField
                            value={formik.values.questionDescription} onChange={(e) => { formik.setFieldValue('questionDescription', e.target.value) }} />
                    </FormControl> */}
                    <FormControl fullWidth className="w-100 mb-5 d-block">
                        <label style={{ marginBottom: '8px', fontSize: '14px', fontWeight: 500 }}>Description</label>
                        {/* <ReactQuill
                            theme="snow"
                            value={formik.values.questionDescription}
                            onChange={(content) => formik.setFieldValue('questionDescription', content)}
                            modules={quillModules}
                            formats={quillFormats}
                            style={{ height: '150px' }}
                        /> */}
                        <PatchedReactQuill
                            setEditorValue={(content) => formik.setFieldValue('questionDescription', content)}
                            editorValue={formik.values.questionDescription}
                            isUpdate={false}
                        />
                    </FormControl>
                    {/* < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Hint</InputLabel>
                        <TextField
                            value={formik.values.questionHint} onChange={(e) => { formik.setFieldValue('questionHint', e.target.value) }} />
                    </FormControl> */}
                    <FormControl fullWidth className="w-100 mb-5 d-block">
                        <label style={{ marginBottom: '8px', fontSize: '14px', fontWeight: 500 }}>Hint</label>
                        {/* <ReactQuill
                            theme="snow"
                            value={formik.values.questionHint}
                            onChange={(content) => formik.setFieldValue('questionHint', content)}
                            modules={quillModules}
                            formats={quillFormats}
                            style={{ height: '150px' }}
                        /> */}
                        <PatchedReactQuill
                            setEditorValue={(content) => formik.setFieldValue('questionHint', content)}
                            editorValue={formik.values.questionHint}
                            isUpdate={false}
                        />
                    </FormControl>
                    <FormControl className="col-12">
                        <label htmlFor="file-upload" style={{ marginBottom: '8px', fontSize: '14px', fontWeight: 500 }} className='form-caption'>
                            <span>
                                Question Hint Images{" "}
                                <sup>
                                    <i className="fa-solid fa-star-of-life star"></i>
                                </sup>
                            </span>

                            <Box className='mt-2 d-flex align-items-center justify-content-center' height={300} width={{ xs: '100%', md: '300px !important' }} border='1px dashed #00000033' borderRadius={5}>
                                <input
                                    type="file"
                                    id="file-upload"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                />
                                <Box className='d-flex flex-column align-items-center justify-content-center'>
                                    <Box component='img' height={36} width={36} src={upload}></Box>
                                    <Typography className='form-caption'>Upload Here</Typography>
                                </Box>
                            </Box>
                        </label>
                    </FormControl>
                </Box>

                <Box className='mt-3 d-flex align-items-start' gap={2}>
                    {uploadedimage && uploadedimage.map((item, index) => (
                        <Box className="image-container" key={index} position="relative" width="fit-content">
                            <Box
                                component="img"
                                className="uploadedImg"
                                alt="img"
                                src={item}
                                height={300}
                                width="auto"
                            />
                            <Box className="cancel-button">
                                <CancelOutlinedIcon sx={{ color: 'black' }} onClick={() => handleRemove(index)}></CancelOutlinedIcon>
                            </Box>
                        </Box>
                    ))}
                </Box>
                {
                    (formik.values.qType === "R" || formik.values.qType === "r" || formik.values.qType === "C") && (
                        <>
                            <Box
                                width="100%"
                                sx={{
                                    borderBottom: "3px dashed #D3D3D3",
                                    opacity: 1,
                                    marginY: 2,
                                }}
                            />
                            <Box className='d-flex justify-content-between w-100 align-items-center my-2 mb-5'>
                                <Typography variant="h6" >
                                    Options for Answers
                                </Typography>
                                <Button
                                    onClick={addOption}
                                    className="bg-grey transform text-light px-4"
                                >
                                    + New Option
                                </Button>
                            </Box>
                            <Grid container spacing={4} className="optionsAnswers">
                                {formik.values.qOptionJson.map((option, index) => {
                                    const optionErrors = (formik.errors.qOptionJson?.[index] as any) || {};
                                    const optionTouched = (formik.touched.qOptionJson?.[index] as any) || {};
                                    return (

                                        <Grid item xs={12} sm={6} key={option.optionId + 1} sx={{ width: "48%" }}>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="stretch"

                                                borderRadius="5px"
                                                border='1px solid #a3a3a3'
                                            >
                                                <Box className="d-flex align-items-stretch">
                                                    <FormControl fullWidth sx={{ "& fieldset": "0px !important" }}>
                                                        <InputLabel shrink={false}>Option - {index + 1}</InputLabel>
                                                        <TextField
                                                            value={parseHtmlToText(option.value)}
                                                            onChange={(e) => {
                                                                const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                    opt.optionId === option.optionId ? { ...opt, value: e.target.value } : opt
                                                                );
                                                                formik.setFieldValue("qOptionJson", updatedOptions);
                                                            }}
                                                            placeholder="Enter Option"
                                                            onBlur={() => formik.setFieldTouched(`qOptionJson[${index}].value`, true)}
                                                            error={optionTouched.value && !!optionErrors.value}
                                                        />
                                                        {ShowError && optionTouched.value && optionErrors.value && (
                                                            <Typography className="text-danger">{optionErrors.value}</Typography>
                                                        )}
                                                    </FormControl>
                                                    {formik.values.qType !== "C" && <Box gap={1} className="d-flex  bg-grey py-2 text-light px-4 align-items-center justify-content-between" width='auto'>
                                                        <Checkbox
                                                            checked={option.optionComment === "yes"}
                                                            onChange={() => {
                                                                const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                    opt.optionId === option.optionId
                                                                        ? { ...opt, optionComment: opt.optionComment === "yes" ? "" : "yes" }
                                                                        : opt
                                                                );
                                                                formik.setFieldValue("qOptionJson", updatedOptions);
                                                            }}
                                                            sx={{ color: "white", p: 0 }}
                                                        />
                                                        <Typography fontSize="14px" whiteSpace='nowrap'>Enable Comment</Typography>
                                                    </Box>}
                                                    {
                                                        index !== 0 && (
                                                            <IconButton
                                                                onClick={() => {
                                                                    const updatedOptions = formik.values.qOptionJson.filter(
                                                                        (opt) => opt.optionId !== option.optionId
                                                                    );
                                                                    formik.setFieldValue("qOptionJson", updatedOptions);
                                                                }}
                                                                className="bg-danger text-light p-2"
                                                                sx={{ borderRadius: "0px" }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        )
                                                    }

                                                </Box>

                                                {formik.values.qType !== "C" && <Box border="1px solid #ccc" className="w-100 p-2">
                                                    <Box className="w-100 mt-4 d-flex justify-content-start flex-wrap" gap={1}>

                                                        <FormControl sx={{ width: '32%' }}>
                                                            <InputLabel id="demo-simple-select-label" shrink={false}>Option Score</InputLabel>
                                                            <TextField
                                                                type="number"
                                                                onBlur={(e) => {
                                                                    const value = parseInt(e.target.value, 10);
                                                                    if (isNaN(value) || value < 0) {
                                                                        toast.error('Number Should be positive')
                                                                        const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                            opt.optionId === option.optionId ? { ...opt, optionScore: 0 } : opt
                                                                        );
                                                                        formik.setFieldValue("qOptionJson", updatedOptions);

                                                                    }
                                                                    else if (value > formik.values.maxScore) {
                                                                        toast.error('Option Score can not be greater than maxScore')
                                                                        const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                            opt.optionId === option.optionId ? { ...opt, optionScore: 0 } : opt
                                                                        );
                                                                        formik.setFieldValue("qOptionJson", updatedOptions);


                                                                    }
                                                                }}
                                                                inputProps={{ min: 0 }}
                                                                value={option.optionScore}
                                                                onChange={(e) => {
                                                                    const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                        opt.optionId === option.optionId ? { ...opt, optionScore: Number(e.target.value) || 0 } : opt
                                                                    );
                                                                    formik.setFieldValue("qOptionJson", updatedOptions);
                                                                }}
                                                                placeholder="Enter Score"
                                                                error={optionTouched.optionScore && !!optionErrors.optionScore}

                                                            />
                                                            {ShowError && optionTouched.optionScore && optionErrors.optionScore && (
                                                                <Typography className="text-danger">{optionErrors.optionScore}</Typography>
                                                            )}

                                                        </FormControl>
                                                        < FormControl sx={{ width: '32%' }}>
                                                            <InputLabel id="demo-simple-select-label" shrink={false}>Minimum Images</InputLabel>
                                                            <TextField
                                                                type="number"
                                                                onBlur={(e) => {
                                                                    const value = parseInt(e.target.value, 10);
                                                                    if (isNaN(value) || value < 0) {
                                                                        toast.error('Number Should be positive')
                                                                        const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                            opt.optionId === option.optionId ? { ...opt, optionImage: 0 } : opt
                                                                        );
                                                                        formik.setFieldValue("qOptionJson", updatedOptions);

                                                                    }
                                                                }}
                                                                inputProps={{ min: 0 }}
                                                                value={option.optionImage}
                                                                onChange={(e) => {
                                                                    const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                        opt.optionId === option.optionId ? { ...opt, optionImage: Number(e.target.value) || 0 } : opt
                                                                    );
                                                                    formik.setFieldValue("qOptionJson", updatedOptions);
                                                                }}
                                                                placeholder="Enter Score"
                                                                error={optionTouched.optionImage && !!optionErrors.optionImage}

                                                            />
                                                            {ShowError && optionTouched.optionImage && optionErrors.optionImage && (
                                                                <Typography className="text-danger">{optionErrors.optionImage}</Typography>
                                                            )}

                                                        </FormControl>
                                                        {option.optionComment === 'yes' && (
                                                            <>
                                                                <FormControl sx={{ width: '32%' }}>
                                                                    <InputLabel shrink={false}>Min. Characters for Comment</InputLabel>
                                                                    <TextField
                                                                        type="number"
                                                                        onBlur={(e) => {
                                                                            const value = parseInt(e.target.value, 10);
                                                                            if (isNaN(value) || value < 0) {
                                                                                toast.error('Number Should be positive')
                                                                                const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                                    opt.optionId === option.optionId
                                                                                        ? { ...opt, minChar: 0 }
                                                                                        : opt
                                                                                );
                                                                                formik.setFieldValue("qOptionJson", updatedOptions);

                                                                            }
                                                                        }}
                                                                        inputProps={{ min: 0 }}
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        value={option.minChar}
                                                                        onChange={(e) => {
                                                                            const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                                opt.optionId === option.optionId
                                                                                    ? { ...opt, minChar: Number(e.target.value) || 0 }
                                                                                    : opt
                                                                            );
                                                                            formik.setFieldValue("qOptionJson", updatedOptions);
                                                                        }}
                                                                        placeholder="50"
                                                                        error={optionTouched.minChar && !!optionErrors.minChar}

                                                                    />
                                                                    {ShowError && optionTouched.minChar && optionErrors.minChar && (
                                                                        <Typography className="text-danger">{optionErrors.minChar}</Typography>
                                                                    )}
                                                                </FormControl>
                                                                <FormControl className="w-33 mt-4" >
                                                                    <InputLabel shrink={false}>
                                                                        Comment Type
                                                                    </InputLabel>
                                                                    <Select
                                                                        onChange={(e) => {
                                                                            const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                                opt.optionId === option.optionId ? { ...opt, optionCommentType: e.target.value || '' } : opt
                                                                            );
                                                                            formik.setFieldValue("qOptionJson", updatedOptions);
                                                                        }}
                                                                        value={option.optionCommentType}
                                                                    >
                                                                        <MenuItem value="text">Text</MenuItem>
                                                                        <MenuItem value="longText">Long Text</MenuItem>
                                                                        <MenuItem value="checkbox">CheckBox</MenuItem>
                                                                        <MenuItem value="time">Time</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                                <FormControl className="mt-4" sx={{ width: 'calc(100% - 35%)' }}>
                                                                    <InputLabel shrink={false}>Comment Label</InputLabel>
                                                                    <TextField
                                                                        className="w-100"
                                                                        placeholder="Write your Question here..."
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        value={option.optionCommentLabel}
                                                                        onChange={(e) => {
                                                                            const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                                opt.optionId === option.optionId ? { ...opt, optionCommentLabel: e.target.value || '' } : opt
                                                                            );
                                                                            formik.setFieldValue("qOptionJson", updatedOptions);
                                                                        }} />
                                                                </FormControl>

                                                            </>
                                                        )}
                                                    </Box>
                                                    {formik.values.qType === "R" || formik.values.qType === "r" && <FormControl fullWidth className="w-100" sx={{ marginTop: '30px' }}>
                                                        <InputLabel id="demo-simple-select-label" shrink={false}>Radio Rating Comment</InputLabel>
                                                        <TextField
                                                            type="text"
                                                            value={option.radioRatingComment}
                                                            onChange={(e) => {
                                                                const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                    opt.optionId === option.optionId ? { ...opt, radioRatingComment: e.target.value || '' } : opt
                                                                );
                                                                formik.setFieldValue("qOptionJson", updatedOptions);
                                                            }}
                                                            placeholder="Enter Rating Comment"

                                                        />
                                                    </FormControl>}
                                                </Box>}

                                            </Box>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </>
                    )
                }
                <Box
                    width="100%"
                    sx={{
                        borderBottom: "3px dashed #D3D3D3",
                        opacity: 1,
                        marginY: 2,
                        mt: 4
                    }}
                />
                <Dialog open={isConfirm} onClose={() => { setisConfirm(false) }}>
                    <DialogContent className="p-4" sx={{ paddingTop: '10px !important' }}>
                        <Box className='d-flex justify-content-end m-0 p-0'><IconButton className="ml-auto" onClick={() => { setisConfirm(false) }}><CancelOutlinedIcon></CancelOutlinedIcon></IconButton></Box>
                        <Typography className="mb-3" variant="h5"> Do you want to create new question ? <br className="mb-0 pb-0" /> <span className="mb-0 pb-0" style={{ fontSize: '16px' }}>Yes will create new question </span> <br className="mt-0 pt-0" /> <span className="mt-0 pt-0" style={{ fontSize: '16px' }}> No will update existing question</span></Typography>
                        <Box className='d-flex align-item-center justify-content-center' gap={2}>
                            <Button style={{ padding: "9px 70px" }}
                                fullWidth
                                // type="submit" 
                                variant="contained"
                                color="primary"
                                className="table-row-background" onClick={() => { setisCreateNew(true); formik.handleSubmit(); setisConfirm(false) }}>Yes</Button>
                            <Button style={{ padding: "9px 70px" }}
                                fullWidth
                                // type="submit"
                                variant="contained"
                                color="primary"
                                className="table-row-background" onClick={() => { setisCreateNew(false); formik.handleSubmit(); setisConfirm(false) }}>No</Button>

                        </Box>
                    </DialogContent>
                </Dialog>
            </form >



        </Box >
    );
};

export default CreateNewQuestion;
